import { PkIdentifier, PkBadge } from '@uefadigital/panenka-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { LineUpTeam } from 'types/ApiResponseInterfaces';
import type { ConfigCompetition } from 'utils/config';
import { isFemale } from 'utils/helpers';
import { translateEntity } from 'utils/translateEntity';

import * as style from './style.module.css';

const DisplayTeamInfo = ({
  team,
  isHomeTeam,
  competition,
}: {
  team: LineUpTeam;
  isHomeTeam: boolean;
  competition: ConfigCompetition | undefined;
}) => {
  const { t } = useTranslation();

  if (!team?.coaches) return null;
  const coach = team.coaches.find((el) => el.role === 'COACH');

  return (
    <PkIdentifier
      alignment={isHomeTeam ? 'left' : 'right'}
      className={`${isHomeTeam ? 'pk-ml--s' : 'pk-mr--s'} pk-py--s pr-py--2t-6b pr-line-height`}
    >
      <span slot={isHomeTeam ? 'prefix' : 'suffix'} className="identifier-prefix">
        <PkBadge
          fallbackImage="club-generic-badge"
          alt="team-logo"
          size={38}
          src={team.team.logoUrl}
          className="pr-badge-size--26"
        />
      </span>
      <span slot="primary" className="pk-text--elevation-01 pk-font-size--m pk-line-height--md pr-font-size--12">
        {translateEntity(team?.team)?.displayName}
      </span>
      <span slot="secondary" className={`pk-font-size--s pk-line-height--lg pr-font-size--10  ${style.coachFont}`}>
        {translateEntity(coach)?.role ?? t(`coach${isFemale(competition?.id) ? '_f' : ''}`)}:{' '}
        {translateEntity(coach?.person)?.name ?? t('coach_name')}
      </span>
    </PkIdentifier>
  );
};

export default memo(DisplayTeamInfo);
